import { BuildingPackage, DocumentPackage, LayoutOptimization } from '@consigli/types';

export type Service = BuildingPackage | DocumentPackage | LayoutOptimization;

export enum ServiceType {
  BUILDING_PACKAGE = 'BUILDING_PACKAGE',
  DOCUMENT_PACKAGE = 'DOCUMENT_PACKAGE',
  LAYOUT_OPTIMIZATION = 'LAYOUT_OPTIMIZATION',
}
